export default {
    LABORATORIAL: 1,
    IMAGEM: 2,
}